import { api } from "./api";

let cachedUrl = null;

/** Returns the configured public WhatsApp link (either a direct wa.me/message/<id>
 *  link or a wa.me/<phone> link, depending on backend config). */
export const getWhatsAppUrl = async () => {
  if (cachedUrl) return cachedUrl;
  try {
    const { data } = await api.get("/settings");
    cachedUrl = data.whatsapp_url || `https://wa.me/${data.whatsapp || "525555555555"}`;
  } catch {
    cachedUrl = "https://wa.me/message/G3MV5LB75ENQG1";
  }
  return cachedUrl;
};

/** Opens the editor's WhatsApp. If the link format supports pre-filled text
 *  (wa.me/<phone>), we attach the message. Business short-links
 *  (wa.me/message/<id>) do NOT support pre-fill, so the message is ignored. */
export const openWhatsApp = async (message) => {
  const url = await getWhatsAppUrl();
  const supportsText = /wa\.me\/\d+/.test(url);
  const final = supportsText && message ? `${url}?text=${encodeURIComponent(message)}` : url;
  window.open(final, "_blank", "noopener,noreferrer");
};
